import { b as o } from "../_baseIsEqual-12d01a44.mjs";
import "../_getTag-4e44633b.mjs";
import "../isArray-0d9c7aaa.mjs";
function t(r, a) {
  return o(r, a);
}
function i(r) {
  return Object.keys(r).forEach((a) => r[a] === void 0 && delete r[a]), r;
}
function d(r, a) {
  return t(
    {
      modifications: r.modifications.map(i),
      variantId: r.variantId,
      upsellGroupId: r.upsellGroupId
    },
    {
      modifications: a.modifications.map(i),
      variantId: a.variantId,
      upsellGroupId: a.upsellGroupId
    }
  );
}
export {
  d as default
};
